import {createSearchQuery, getParams, getQueryParams, translate} from '@src/helpers'
import {COUNTRY_FLAGS} from '@assets/CountryFlags'
import {Dropdown} from 'react-bootstrap'
import React, {Fragment, useEffect, useState} from 'react'
import {getFibreStatus} from '@components/VerificationLegend/VerificationLegend'
import {useSelector, useDispatch} from 'react-redux'
import _ from 'lodash-es'
import {E_ProcessClaimedStatus} from '@src/types'
import {Redirect, useLocation, useHistory} from 'react-router-dom'
import {setPreviousUrl} from '@redux/actions/navigatorAction'
import FibretraceLabelMarkup from '@components/module-components/POSMap/helper/FibretraceLabelMarkup'

type DetailViewProcessProps = {
  data: any,
  order?: any,
  className?: string | ''
  classNameWrapper?: string | ''
}

const DetailViewProcess: React.FC<DetailViewProcessProps> = (
  {
    className = '', classNameWrapper = '',
    data,
    order,
    dataMap
  }) => {

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const langData = useSelector((state: any) => state.currentLanguage) as any
  const statusDetails = getFibreStatus(data.claimed_status as E_ProcessClaimedStatus)

  const [loading, setLoading] = useState(false)

  const [showConnectedOrders, setShowConnectedOrders] = useState(false)
  const [connectedOrders, setConnectedOrders] = useState([])

  const [showDetailProcessMobile, setShowDetailProcessMobile] = useState(false)
  const [processPosition, setProcessPosition] = useState('')

  /**
   * @todo
   * work with backend to return country alpha code, so FE can render flag directly
   */
  const journeyItemClass = () => {
    return `journey-item ${className} ${showDetailProcessMobile ? ' mexpanded ' : ''} ${showConnectedOrders ? ' expanded ' : ''} ${!data.connected_orders.length ? '' : 'has-connected-orders'}`
  }

  const toggleJourneyItemMobile = () => {
    try {
      setShowDetailProcessMobile(!showDetailProcessMobile)
    } catch (e) {
      console.error(e)
    }
  }

  const toggleConnectedOrders = () => {
    try {
      setLoading(true)

      setConnectedOrders(data.connected_orders.map((c) => {
        c.processes.sort((a, b) => b.process_position - a.process_position)
        return c
      }).reverse())

      setLoading(false)
      setShowConnectedOrders(!showConnectedOrders)
      setShowDetailProcessMobile(!showConnectedOrders)
    } catch (err) {
      console.error(err)
    } finally {
    }
  }

  const getCountryFlag = (alpha2Code = 0) => {
    if (alpha2Code) return COUNTRY_FLAGS[alpha2Code]
    return false
  }

  const handleClickProcessName = (data) => {
    try {
      const {brand} = getParams()
      let qs = createSearchQuery({...getQueryParams(data.b2c_url), brand})
      console.log('data', data)
      dispatch(setPreviousUrl({
        previous: {...location},
        query: {
          viewMode: 'detailView',
          process_position: processPosition
        }
      }))

      // setRedirectUrl(`/step-detail?${qs}`)
      // setRedirectNow(true);

      history.push(`/step-detail?${qs}`)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    const t = _.find(dataMap, (m: any) => m.process_id === data.process_id)
    if (t) setProcessPosition(t?.custom_order)
  }, [])

  return (
    <Fragment>
      <div className={`journey-item-wrapper ${classNameWrapper} ${showConnectedOrders ? ' expanded ' : ''}`}>
        <div
          className={journeyItemClass()}>

          <div className="journey-item-toggle-mobile">
            <span onClick={() => {
              toggleJourneyItemMobile()
            }} />
          </div>

          <div className="journey-item-process">
            <p
              className={'journey-header-mobile'}>
              <b>{translate(langData.localize, 'LABEL.B2C.DETAIL_VIEW.HEADER.PROCESS')}</b></p>
            <p><b onClick={() => {
              handleClickProcessName(data)
            }}>
              {processPosition
                ? <span className={'journey-item-position'}>{processPosition}</span> : null}{data.process_name}</b></p>
            {order?.order_code && <h5><span className={'d-none'}>{order?.order_code}</span></h5>}
          </div>

          <div className="journey-item-time">
            <p
              className={'journey-header-mobile'}>{translate(langData.localize, 'LABEL.B2C.DETAIL_VIEW.HEADER.DATE_TIME')}</p>
            {data?.process_date}
          </div>

          <div className="journey-item-manufacturer">
            <p
              className={'journey-header-mobile'}>{translate(langData.localize, 'LABEL.B2C.DETAIL_VIEW.HEADER.MANUFACTURER')}</p>
            <p><b>{data?.process_manufacturer_name}</b></p>

            <React.Fragment>
              <div className={'d-inline-flex flex-column align-items-flex-start '}>
                <span className={statusDetails.badgeClassName}>
                  {statusDetails.icon}&nbsp;
                  {translate(langData.localize, statusDetails.label)}
                </span>

                <FibretraceLabelMarkup poz={data} className={'text-center'}
                                       style={{fontSize: '11px', marginTop: '3px', color: '#797A7C'}} />
              </div>
            </React.Fragment>

          </div>

          <div className="journey-item-country">
            <p
              className={'journey-header-mobile'}>{translate(langData.localize, 'LABEL.B2C.DETAIL_VIEW.HEADER.LOCATION')}</p>

            {getCountryFlag(data?.alpha2Code) &&
              <span className={'journey-item-country-flag rounded-circle mr-2'}
                    style={{
                      backgroundImage: `url("${getCountryFlag(data?.alpha2Code)}")`
                    }}
              />}

            <span className={'d-none d-md-inline-block'}>{data?.process_location || ''}</span>
          </div>

          <div className="journey-item-actions">
            {
              !data.connected_orders.length ? null
                : <Dropdown
                  className={'fibre-dropdown-corders'}
                  onSelect={(eventKey: any, event: Object) => {

                  }}
                  onToggle={async (isOpen: boolean,
                                   event,
                                   metadata: {
                                     source: 'select' | 'click' | 'rootClose' | 'keydown'
                                   }) => {
                    toggleConnectedOrders()
                  }}
                >
                  <Dropdown.Toggle variant="success"
                                   className={'w-100 fz-12'}

                  >
                    {translate(langData.localize, 'LABEL.ORDER_PROCESS.CONNECTED_ORDERS_NUMBER', '',
                      {
                        total: data.connected_orders.length
                      })}
                  </Dropdown.Toggle>

                </Dropdown>
            }

          </div>

        </div>

        {
          loading
            ? <p>loading</p>
            : showConnectedOrders && _.map(connectedOrders, (order: any) => {
            return _.map(order.processes, (process: any) => {
              return <DetailViewProcess dataMap={dataMap}
                                        key={process.process_id}
                                        order={order}
                                        data={process}
              />
            })
          })
        }

      </div>

    </Fragment>


  )
}

export default DetailViewProcess